import Button from '@/components/common/Button';
import useSettings from '@/hooks/useSettings';
import { formatPrice } from '@/utils/format';
import moment from 'moment';
import { useState } from 'react';
interface BoletoPaymentProps {
  barcode: string;
  boletoUrl: string;
  amount: number;
  expirationDate: string;
  onOpenBillet: () => void;
}

const BoletoPayment = ({
  barcode,
  amount,
  expirationDate,
  onOpenBillet
}: BoletoPaymentProps) => {
  const [isCopy, setIsCopy] = useState(false);
  const settings = useSettings();

  const copyBarCode = async () => {
    setIsCopy(true);
    navigator.clipboard.writeText(barcode);

    await new Promise((r) => setTimeout(r, 2000));
    setIsCopy(false);
  };

  return (
    <div className="flex flex-col justify-center items-center gap-3 w-full">
      <div className="flex flex-col w-full px-14 mt-3 mb-3 text-center">
        <span className="text-gray-700 leading-relaxed">
          O acesso ao produto digital será enviado via e-mail depois que o boleto for
          pago. A confirmação do pagamento pode levar até 48 horas.
        </span>
      </div>

      <div className="flex flex-col gap-5 mb-3">
        <div className="flex flex-col px-14 mt-5 text-center w-full">
          <span style={{ color: settings.text.color.secondary }} className="text-white">
            Valor do boleto
          </span>
          <span
            style={{ color: settings.text.color.primary }}
            className="font-bold text-white"
          >
            {formatPrice(amount)}
          </span>
        </div>
        <div className="flex flex-col justify-center text-center">
          <span style={{ color: settings.text.color.secondary }} className="text-white">
            Data de vencimento
          </span>
          <span
            style={{ color: settings.text.color.primary }}
            className="font-bold text-white"
          >
            {moment(expirationDate, 'YYYY/MM/DD').format('DD/MM/YYYY')}
          </span>
        </div>
        <div className="flex flex-col justify-center text-center">
          <span style={{ color: settings.text.color.secondary }} className="text-white">
            Código do Boleto
          </span>
          <span
            style={{ color: settings.text.color.primary }}
            className="font-bold sm:text-sm text-xs text-white"
          >
            {barcode}
          </span>
        </div>
      </div>

      <div className="flex justify-center w-full">
        <img
          src={`https://barcode.tec-it.com/barcode.ashx?data=${barcode}&code=Code128&dpi=96&dataseparator=`}
          alt="Boleto"
          className="sm:w-96 h-16 sm:h-24 mx-auto"
        />
      </div>

      <div className="flex flex-col gap-3 w-full justify-center items-center mt-3">
        <button
          onClick={copyBarCode}
          className="w-full py-3 px-4 border border-green-700 bg-white hover:bg-green-50/60 active:bg-green-100 rounded-md text-gray-700 font-medium flex items-center justify-center gap-2 transition-colors"
          disabled={false}
        >
          {isCopy ? (
            <span className="font-semibold text-green-700">Código copiado</span>
          ) : (
            <div className="flex items-center justify-center gap-2">
              <img className="w-4 h-4" src="/assets/copy-green.svg" alt="icone de copiar" />
              <span className="font-semibold text-green-700">Copiar código</span>
            </div>
          )}
        </button>
        <Button
          style={{
            backgroundColor: settings.payButton.color,
            color: settings.payButton.text.color
          }}
          sizes="sm"
          onClick={onOpenBillet}
        >
          Imprimir Boleto
        </Button>
      </div>
    </div>
  );
};

export default BoletoPayment; 
